import { render, staticRenderFns } from "./previewProjectHandbook.vue?vue&type=template&id=6cbf6eab&scoped=true"
import script from "./previewProjectHandbook.vue?vue&type=script&lang=js"
export * from "./previewProjectHandbook.vue?vue&type=script&lang=js"
import style0 from "./previewProjectHandbook.vue?vue&type=style&index=0&id=6cbf6eab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf6eab",
  null
  
)

export default component.exports